export default __webpack_public_path__ + "static/media/Banner2022_Restaurant-min.557d8a7f.png";